export const ADD_CREATORS_BY_URI_MUTATION = `
    mutation AddCreatorsByURI($account_id: Int!, $uris: String!, $project_id: Int!) {
        addCreatorsByURI(account_id: $account_id, uris: $uris, project_id: $project_id) {
            social_channel_type
            url
            account_creator_id
            account_social_channel_id
            label
            platform_uuid
            handle
            avatar
            first_name
            last_name
            views
            followers
            posts
            likes
            comments
            error_message {
                message
                code
            }
        }
    }
`;

export const ADD_CREATOR_MUTATION = `
    mutation AddCreator($account_id: Int!, $username: String!, $email: String, $first_name: String, $last_name: String, $avatar: String, $ethnicity: [String], $gender: String, $social_channels: [String], $custom_properties: [CustomPropertyInput]){
        addCreator(account_id: $account_id, username: $username, email: $email, first_name: $first_name, last_name: $last_name, avatar: $avatar, ethnicity: $ethnicity, gender: $gender, social_channels: $social_channels, custom_properties: $custom_properties) {
            id
            username
            type
            first_name
            last_name
            email
            avatar
            ethnicity
            gender
            social_channels {
                id
                handle
                label
                description
                type
                url
                avatar
            }
            custom_properties {
                key
                value
            }
            products {
                id
                name
                image_url
                custom_properties {
                    key
                    value
                }
                product_retailers {
                    id
                    sku
                    url
                    image_url
                }
            }
        }
    }
`;

export const ADD_CREATOR_BY_ACCOUNT_CREATOR_ID_MUTATION = `
    mutation AddCreator($project_id: Int!,$account_creator_id: Int!,$deliverable_count: Int){
        addCreator(project_id: $project_id, account_creator_id: $account_creator_id, deliverable_count: $deliverable_count) {
            id
            deliverable_count
            notes
            initial_quote
            favorite
            confirmed
            example_content
            avatar
            decision
            tiktok_reach
            tiktok_impressions
            tiktok_engagement_rate
            instagram_reach
            instagram_impressions
            instagram_engagement_rate
            youtube_reach
            youtube_impressions
            youtube_engagement_rate
            social_channels {
                id
                handle
                description
                type
                url
                avatar
                reach
                impressions
            }
            associates {
                id
                type
            }
            deliverables {
                id
                name
                type
                status
                assets {
                    id
                    versions {
                        id
                        title
                        description
                        version
                        status
                    }
                }
                creator {
                    id
                    account_creator {
                        id
                        username
                        avatar
                    }
                }
                products {
                    id
                    name
                    image_url
                    custom_properties {
                        key
                        value
                    }
                    product_retailers {
                        id
                        sku
                        url
                        image_url
                    }
                }
                destinations {
                    id
                    url
                    status
                    project_deliverable {
                        id
                        name
                        type
                        status
                    }
                }
                custom_properties {
                    key
                    value
                }
            }
            contract {
                id
                status
                contract_value
                kill_fee
                content_ownership_id
                content_rights
                content_rights_expiration_date
                ecom_asset_ownership
                indeminity
                whitelisting
                whitelisting_expiration
                term_date
                notes
                uploads {
                    id
                    filename
                    thumbnail
                    tag
                    type
                }
            }
            custom_properties {
                key
                value
            }
            notes
            initial_quote
            favorite
            confirmed
            example_content
            avatar
            decision
            account_creator {
                id
                username
                type
                first_name
                last_name
                email
                avatar
                ethnicity
                gender
                verticals
                w9
                w9_expiration_date
                created_at
                updated_at
                social_channels {
                    id
                    handle
                    label
                    description
                    type
                    url
                    avatar
                }
            }
            custom_properties {
                key
                value
            }
            products {
                id
                name
                image_url
                custom_properties {
                    key
                    value
                }
                product_retailers {
                    id
                    sku
                    url
                    image_url
                }
            }
        }
    }
`;

export const UPDATE_CREATOR_MUTATION = `
    mutation UpdateCreator(
            $account_id: Int!,
            $account_creator_id: Int!,
            $username: String,
            $email: String,
            $phone: String,
            $first_name: String,
            $last_name: String,
            $avatar: String,
            $ethnicity: [String],
            $gender: String,
            $social_channels: [String],
            $custom_properties: [CustomPropertyInput],
            $verticals: [String],
            $w9: String,
            $w9_expiration_date: String,
        ) {
        UpdateCreator(
            account_id: $account_id,
            account_creator_id: $account_creator_id,
            username: $username,
            email: $email,
            phone: $phone,
            first_name: $first_name,
            last_name: $last_name,
            avatar: $avatar,
            ethnicity: $ethnicity,
            gender: $gender,
            social_channels: $social_channels,
            custom_properties: $custom_properties,
            verticals: $verticals,
            w9: $w9,
            w9_expiration_date: $w9_expiration_date,
        ) {
            id
            username
            type
            first_name
            last_name
            email
            phone
            avatar
            ethnicity
            gender
            verticals
            w9
            w9_expiration_date
            created_at
            updated_at
            social_channels {
                id
                handle
                label
                description
                type
                url
                avatar
            }
            user {
                id
                first_name
                last_name
                username
                email
                phone
                avatar
                verified
                last_login
            }
            custom_properties {
                key
                value
            }
        }
    }
`;

export const REMOVE_PROJECT_CREATOR_MUTATION = `
    mutation RemoveCreator($project_id: Int!, $project_creator_id: Int!) {
        removeCreator(project_id: $project_id, project_creator_id: $project_creator_id)
    }
`;

export const REMOVE_PROJECT_CREATOR_SOCIAL_CHANNEL_MUTATION = `
    mutation RemoveCreatorSocialChannel($project_id: Int!, $project_creator_social_channel_id: Int!){
        removeCreatorSocialChannel(project_id: $project_id, project_creator_social_channel_id: $project_creator_social_channel_id)
    }
`;

export const ADD_CREATOR_SOCIAL_CHANNEL_MUTATION = `
    mutation AddCreatorSocialChannel($account_id: Int!, $project_id: Int!, $project_creator_id: Int!, $uri: String!) {
        addCreatorSocialChannel(
            account_id: $account_id
            project_id: $project_id
            project_creator_id: $project_creator_id
            uri: $uri
        ) {
            id
            label
            handle
            description
            type
            url
            avatar
            reach
            impressions
        }
    }
`;

export const UPDATE_PROJECT_CREATOR_MUTATION = `
    mutation UpdateCreator(
        $project_id: Int!,
        $project_creator_id: Int!,
        $deliverable_count: Int,
        $custom_properties: [CustomPropertyInput],
        $notes: String,
        $initial_quote: Float,
        $favorite: Boolean,
        $confirmed: Boolean,
        $example_content: String,
        $avatar: String,
        $decision: ProjectCreatorDecisionEnum
        $tiktok_reach: BigInt,
        $tiktok_impressions: BigInt,
        $tiktok_engagement_rate: Float,
        $instagram_reach: BigInt,
        $instagram_impressions: BigInt,
        $instagram_engagement_rate: Float,
        $youtube_reach: BigInt,
        $youtube_impressions: BigInt,
        $youtube_engagement_rate: Float
        $client_notes: String
    ) {
        updateCreator(
            project_id: $project_id,
            project_creator_id: $project_creator_id,
            deliverable_count: $deliverable_count,
            custom_properties: $custom_properties,
            notes: $notes,
            initial_quote: $initial_quote,
            favorite: $favorite,
            confirmed: $confirmed,
            example_content: $example_content,
            avatar: $avatar,
            decision: $decision,
            tiktok_reach: $tiktok_reach,
            tiktok_impressions: $tiktok_impressions,
            tiktok_engagement_rate: $tiktok_engagement_rate,
            instagram_reach: $instagram_reach,
            instagram_impressions: $instagram_impressions,
            instagram_engagement_rate: $instagram_engagement_rate,
            youtube_reach: $youtube_reach,
            youtube_impressions: $youtube_impressions,
            youtube_engagement_rate: $youtube_engagement_rate
            client_notes: $client_notes
        ) {
            id
            deliverable_count
            notes
            initial_quote
            favorite
            confirmed
            example_content
            avatar
            decision
            tiktok_reach
            tiktok_impressions
            tiktok_engagement_rate
            instagram_reach
            instagram_impressions
            instagram_engagement_rate
            youtube_reach
            youtube_impressions
            youtube_engagement_rate
            client_notes
            account_creator {
                id
                username
                type
                first_name
                last_name
                email
                avatar
                ethnicity
                gender
                verticals
                w9
                w9_expiration_date
                created_at
                updated_at
            }
            deliverables {
                id
                name
                type
                status
            }
            associates {
                id
                type
            }
            custom_properties {
                key
                value
            }
            contract {
                id
                status
                contract_value
                kill_fee
                content_ownership_id
                content_rights
                content_rights_expiration_date
                ecom_asset_ownership
                indeminity
                whitelisting
                whitelisting_expiration
                term_date
                notes
            }
            social_channels {
                id
                handle
                label
                description
                type
                url
                avatar
                reach
                impressions
            }
        }
    }
`;

export const PROJECT_CREATOR_ATTACH_PRODUCTS_MUTATION = `
    mutation AttachProducts($project_id: Int!, $project_creator_id: Int!, $product_ids: [Int]!) {
        attachProducts(project_id: $project_id, project_creator_id: $project_creator_id, product_ids: $product_ids) {
            id
            name
            image_url
            custom_properties {
                key
                value
            }
            product_retailers {
                id
                sku
                url
                image_url
                retailer {
                    id
                    name
                }
            }
        }
    }
`;

export const PROJECT_CREATOR_DETACH_PRODUCTS_MUTATION = `
    mutation DetachProducts($project_id: Int!, $project_creator_id: Int!, $product_ids: [Int]!) {
        detachProducts(project_id: $project_id, project_creator_id: $project_creator_id, product_ids: $product_ids) {
            id
            name
            image_url
            custom_properties {
                key
                value
            }
            product_retailers {
                id
                sku
                url
                image_url
                retailer {
                    id
                    name
                }
            }
        }
    }
`;

export const PROJECT_CREATOR_SYNC_PRODUCTS_MUTATION = `
    mutation SyncProducts($project_id: Int!, $project_creator_id: Int!, $product_ids: [Int]!) {
        syncProducts(project_id: $project_id, project_creator_id: $project_creator_id, product_ids: $product_ids) {
            id
            name
            image_url
            custom_properties {
                key
                value
            }
            product_retailers {
                id
                sku
                url
                image_url
                retailer {
                    id
                    name
                }
            }
        }
    }
`;

export const PROJECT_CREATOR_SYNC_BRIEFINGFILES_MUTATION = `
mutation SyncBriefingFiles($project_id: Int!, $project_creator_id: Int!, $upload_ids: [Int]!, $deliverable_id: Int) {
    syncBriefingFiles(project_id: $project_id, project_creator_id: $project_creator_id, upload_ids: $upload_ids, deliverable_id: $deliverable_id) {
        id
        deliverable_id
        filename
        thumbnail
        tag
        type
    }
}
`;

export const PROJECT_CREATOR_INVITE_MUTATION = `
    mutation InviteCreators ($workspace_id: Int!, $project_id: Int!, $project_creator_ids: [Int]!, $notify: Boolean) {
        inviteCreators(
            workspace_id: $workspace_id, project_id: $project_id, project_creator_ids: $project_creator_ids,
            notify: $notify
        ) {
            creator{
                id
            }
            error
            link
            accepted
            invited
            status
        }
    }
`;
